import React, { useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title } from 'app/src/styles';
import { useNavigate } from 'app/src/utils/routing';

import { CREATE_EVENT_TYPE, EVENT_TYPES } from './queries';

export const FIELDS = {
  name: {
    label: 'Name',
    rules: { required: true },
  },
  parentId: {
    label: 'Parent',
    blank: 'null',
  },
  emoji: {
    label: 'Emoji',
    rules: {
      pattern: {
        value: /^[\p{Emoji}\w]{0,1}$/u,
        message: 'Only one emoji or letter allowed',
      },
    },
  },
  hasAmount: {
    label: 'Prompt for an amount?',
    type: 'boolean',
  },
  amountLabel: {
    label: 'Custom label for amount',
    type: 'hidden',
  },
  hasDuration: {
    label: 'Prompt for duration?',
    type: 'boolean',
  },
  hasThings: {
    label: 'Prompt to select things?',
    type: 'boolean',
  },
};

const NewEventType = () => {
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const { control, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data: selects } = useQuery(EVENT_TYPES);

  const [createEventType] = useMutation(CREATE_EVENT_TYPE, {
    onCompleted: () => navigate('/event-types'),
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    createEventType({ variables: { input: prepareInput(input, FIELDS) } });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.parentId.select = [
      { value: '', label: 'NONE' },
      ...selects.eventTypes
        .map(entry => ({ value: entry.id, label: entry.name }))
    ];
  }

  if (watch('hasAmount')) {
    fields.amountLabel = { ...fields.amountLabel, type: 'string' };
  }

  return (
    <View>
      <Title>Add EventType</Title>

      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default NewEventType;
